<template>
  <fragment>
    <Title title="按工作年限分析" className="ny-title-small"></Title>
    <div class="layout-view withoutTitle pb0">
      <EchartsLayout :option="option"></EchartsLayout>
    </div>
  </fragment>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import Title from "@/components/common/Title.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    Title,
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "post",
        url: `/home/getStaffAnalysisList`,
        param: {
          dimension: "work_years",
        },
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              let itemLevel = item.level.replace(/年/, "").replace(/以上/, "+");
              arr.push([itemLevel, item.number]);
            });
          // 更新配置
          this.option = {
            grid: {
              right: 0,
              left: 150,
            },
            series: [
              {
                type: "bar",
                name: "数量",
                barMaxWidth: 75,
                showItemStyle: true,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 1,
                    x2: 0,
                    y2: 0,
                    colorStops: [
                      { offset: 1, color: "rgba(0, 97, 206, 1)" },
                      { offset: 0, color: "rgba(45, 198, 248, 1)" },
                    ],
                    globalCoord: false,
                  },
                  borderRadius: 50,
                },
              },
            ],
            tooltip: { textStyle: { fontSize: 54 } },
            xAxis: {
              axisLine: { lineStyle: { color: "white" } },
              type: "category",
              axisLabel: {
                interval: 0,
                textStyle: {
                  fontSize: 54,
                  fontWeight: 700,
                },
              },
            },
            yAxis: {
              axisLine: { lineStyle: { color: "white" } },
              boundaryGap: [0, 0.01],
              type: "value",
              axisLabel: {
                textStyle: {
                  fontSize: 54,
                  fontWeight: 700,
                },
              },
            },
            dataset: {
              source: [["level", "number"], ...arr],
            },
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
